export const DEPOSIT_ACTIONS = {
  SEARCH_INPUTS: "SEARCH_INPUTS",
  SELECT_INPUTS: "SELECT_INPUTS",
  GET_DEPOSITS: "GET_DEPOSITS",
  ADD_DEPOSIT: "ADD_DEPOSIT",
  EDIT_DEPOSIT: "EDIT_DEPOSIT",
  DELETE_DEPOSIT: "DELETE_DEPOSIT",
  SELECT_DEPOSIT: "SELECT_DEPOSIT",
};
